module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/2081fa78ed270568e998a3a568b38dc4.png";